module.exports = __webpack_public_path__ + "static/media/5.104be2a7.jpg";